import React, { useEffect, useState } from 'react';
import { ArrowRight, ChevronRight } from 'lucide-react'; // Ensure you have lucide-react installed
import { Link, useNavigate } from 'react-router-dom';
import { Get_Api } from '../../API_URL';
import { toast } from 'react-toastify';

const jobsData = [
    {
        id: 1,
        title: "Business Analyst – Payments Domain",
        experience: "10 Years",
        location: "Pune (Hybrid work Mode) India",
        role: "Enterprise Platform Advisory Manager",
        jobNumber: "R00298551",
        description: "We are seeking an experienced Business Analyst (Payments Domain) who can bridge the gap between business goals and technology execution. You'll work closely with our clients, product owners, and engineering teams to define and translate business needs into high-impact, technology-driven payment solutions."
    },
    {
        id: 2,
        title: "Java Full Stack Developer",
        experience: "5-8 Years",
        location: "Bangalore (Remote) India",
        role: "Senior Software Engineer",
        jobNumber: "R00298552",
        description: "Looking for a passionate Full Stack Developer with strong expertise in Java, Spring Boot, and React. You will be responsible for end-to-end development of scalable web applications and microservices."
    },
    {
        id: 3,
        title: "UI/UX Designer",
        experience: "3-5 Years",
        location: "Mumbai (On-site) India",
        role: "Creative Design Lead",
        jobNumber: "R00298553",
        description: "Join our creative team to design intuitive and engaging user experiences. You should have a strong portfolio showcasing your skills in Figma, Adobe XD, and user-centric design principles."
    },
    {
        id: 4,
        title: "DevOps Engineer",
        experience: "6+ Years",
        location: "Hyderabad (Hybrid) India",
        role: "Cloud Infrastructure Specialist",
        jobNumber: "R00298554",
        description: "We need a DevOps expert to manage our cloud infrastructure on AWS/Azure. You will be responsible for CI/CD pipelines, containerization (Docker/Kubernetes), and ensuring high availability."
    },
];

const LatestOpenings = () => {

    const navigate = useNavigate()
    const [Alljobs, setAlljobs] = useState([]);
    const [Isloading, setIsloading] = useState(false);
    const [activeJob, setActiveJob] = useState(null);

    const GetAlljobs = async () => {
        try {
            setIsloading(true)
            const response = await Get_Api("api/admin/GetAllJobs");
            setAlljobs(response?.data || [])
            setIsloading(false)
        } catch (error) {
            setIsloading(false)
            toast.error(error?.response?.message || "Failed to upload requirement");
            console.error("Error uploading requirement:", error);
        }
    }

    useEffect(() => {
        GetAlljobs();
    }, []);

    useEffect(() => {
        if (Alljobs.length > 0 && activeJob === null) {
            setActiveJob(Alljobs[0]);
        }
    }, [Alljobs, activeJob]);

    const Loader = () => {
        return (
            <div className="flex items-center justify-center py-10 h-[400px]">
                <div className="w-10 h-10 border-4 border-[#01386A] border-t-transparent rounded-full animate-spin"></div>
            </div>
        );
    };

    return (
        <section className="w-full bg-white pb-16 lg:pb-24">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">

                <h2 className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora mb-12">
                    Latest Openings
                </h2>
                {Isloading ?
                    <Loader />
                    :
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-[16px]">
                        <div className={`flex flex-col gap-4 ${Alljobs.length > 3 ? "lg:max-h-[700px] overflow-y-auto pr-2" : ""}`} >
                            {Alljobs?.map((job) => (
                                <div
                                    key={job?._id}
                                    onClick={() => setActiveJob(job)}
                                    className={`cursor-pointer p-6 lg:p-[36px] transition-all duration-300 bg-[#F0F0F0] group relative ${activeJob?._id === job?._id ? 'shadow-md' : 'hover:bg-gray-100'}`}
                                >
                                    <h3 className="text-[#01386A] lg:text-[20px] text-[16px] font-[600] font-sora mb-[30px]">
                                        {job?.Title}
                                    </h3>
                                    <p className="text-[#49577A] text-[14px] lg:text-[16px] leading-[24px] font-[700] font-sora">
                                        Experience: <span className="font-[500] font-graphik">{job?.Experience} + years</span> | Location:
                                        <span className='font-[500] font-graphik'>
                                            &nbsp; {job?.Location?.City} {job?.Location?.Country}
                                        </span>
                                    </p>
                                    <div
                                        className={`absolute bottom-0 left-0 h-[4px] w-full transition-colors duration-300 ${activeJob?._id === job?._id ? 'bg-[#ED6800]' : 'bg-[#01386A]'} `}
                                    />
                                </div>
                            ))}
                        </div>
                        <div>
                            <div className="border border-[#01386A80] p-8 lg:p-[36px] h-full bg-white shadow-sm flex flex-col justify-between">

                                <div>
                                    <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora lg:mb-[40px] mb-[20px]">
                                        {activeJob?.Title}
                                    </h3>

                                    <div className="space-y-2 mb-8 text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-sora">
                                        <p className=' '>
                                            <span className="font-[600] lg:text-[20px] text-[16px] text-[#49577A]">Job:</span> {activeJob?.Title}
                                        </p>
                                        <p className=''>
                                            <span className="font-[600] lg:text-[20px] text-[16px] text-[#49577A]">Job Number:</span> {activeJob?._id?.slice(0, 5)}
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <p className="font-[600] font-sora lg:text-[20px] text-[16px] text-[#49577A] mb-2">Job description</p>
                                        <div
                                            className="text-[#49577A] lg:text-[16px] text-[14px] font-graphik font-[500] leading-[24px] text-justify"
                                            dangerouslySetInnerHTML={{ __html: activeJob?.AboutRole }}
                                        />

                                    </div>
                                </div>
                                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-[16px]">
                                    <div className="mt-8">
                                        <button onClick={() => { navigate(`/careers-apply/${activeJob?._id}`) }} className="flex items-center gap-2 px-8 py-3 border border-[#ED6800] text-[#ED6800] lg:text-[16px] text-[14px] font-graphik font-[500] hover:bg-[#ED6800] hover:text-white transition-all duration-300 group">
                                            Apply Now
                                            <ArrowRight size={20} className="transition-transform duration-300 group-hover:translate-x-1" />
                                        </button>
                                    </div>
                                    <div className="mt-8 ml-16">
                                        <Link to={`/all-openings`} className="text-[#0E2A62] lg:text-[16px] text-[14px] font-graphik font-[500] flex items-center gap-1 hover:gap-2 transition-all p-4 ml-6">
                                            View All Openings <ChevronRight size={16} />
                                        </Link>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                }
            </div>
        </section>
    );
};

export default LatestOpenings;